import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMic } from 'react-icons/fi';
import HistoryCard from '../components/HistoryCard';
import { getHistory, deleteFromHistory } from '../utils/history';
import Title from '../assets/Title.png';
import './History.css';

const History = () => {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    setHistory(getHistory());
  }, []);

  const handleDelete = (id) => {
    setDeleteConfirm(id);
  };

  const confirmDelete = () => {
    if (deleteConfirm) {
      deleteFromHistory(deleteConfirm);
      setHistory(getHistory());
      setDeleteConfirm(null);
    }
  };

  const cancelDelete = () => {
    setDeleteConfirm(null);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      className="page history-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <header className="header">
        <Link to="/" className="logo">
          <img src={Title} alt="Unscramble Logo" className="logo-image" />
        </Link>
      </header>

      <main className="history-main">
        <motion.h1
          className="history-title"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Past Rambles
        </motion.h1>

        {history.length === 0 ? (
          <motion.div
            className="empty-state"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <span className="empty-emoji">🐿️</span>
            <h2>No rambles yet</h2>
            <p>Your past thoughts will appear here after you record them.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/record')}
            >
              <FiMic className="btn-icon" />
              Start Your First Ramble
            </button>
          </motion.div>
        ) : (
          <motion.div
            className="history-grid"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {history.map((item) => (
              <motion.div key={item.id} variants={itemVariants}>
                <HistoryCard
                  item={item}
                  onDelete={handleDelete}
                />
              </motion.div>
            ))}
          </motion.div>
        )}
      </main>

      {/* Delete confirmation modal */}
      <AnimatePresence>
        {deleteConfirm && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={cancelDelete}
          >
            <motion.div
              className="modal-content"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Delete this ramble?</h3>
              <p>This action cannot be undone.</p>
              <div className="modal-actions">
                <button className="btn btn-secondary" onClick={cancelDelete}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={confirmDelete}>
                  Delete
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default History;